import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function LevelIndicatorIcon(_ref) {
  var variant = _ref.variant;

  var _useLevelIndicatorIco = useLevelIndicatorIcon(variant),
      bgFill = _useLevelIndicatorIco.bgFill,
      occupiedFill = _useLevelIndicatorIco.occupiedFill,
      pointerDirection = _useLevelIndicatorIco.pointerDirection,
      occupiedFillDirection = _useLevelIndicatorIco.occupiedFillDirection;

  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    fill: "none",
    viewBox: "0 0 128 128",
    children: [/*#__PURE__*/_jsx("path", {
      fill: bgFill,
      d: "M21.008 106.992c-1.25 1.25-3.283 1.255-4.468-.056a63.997 63.997 0 0 1 11.904-96.15 64 64 0 0 1 83.016 96.15c-1.185 1.311-3.218 1.306-4.468.056s-1.242-3.27-.064-4.587a57.6 57.6 0 0 0 10.287-60.448A57.595 57.595 0 0 0 64 6.4a57.6 57.6 0 0 0-42.928 96.005c1.178 1.317 1.186 3.337-.064 4.587"
    }), /*#__PURE__*/_jsx("path", {
      fill: occupiedFill,
      d: occupiedFillDirection
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_d_4156_17034)",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#1C1C33",
        d: pointerDirection
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx(SvgFilter, {
        variant: variant
      })
    })]
  });
}
export default LevelIndicatorIcon;

function SvgFilter(_ref2) {
  var variant = _ref2.variant;

  var _useMemo = useMemo(function () {
    return variantFilterValues[variant];
  }, [variant]),
      width = _useMemo.width,
      height = _useMemo.height,
      x = _useMemo.x,
      y = _useMemo.y,
      id = _useMemo.id;

  return /*#__PURE__*/_jsxs("filter", {
    id: id,
    width: width,
    height: height,
    x: x,
    y: y,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    children: [/*#__PURE__*/_jsx("feFlood", {
      floodOpacity: "0",
      result: "BackgroundImageFix"
    }), /*#__PURE__*/_jsx("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/_jsx("feOffset", {
      dy: "4"
    }), /*#__PURE__*/_jsx("feGaussianBlur", {
      stdDeviation: "2"
    }), /*#__PURE__*/_jsx("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }), /*#__PURE__*/_jsx("feColorMatrix", {
      values: "0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0 0.2 0 0 0 0.25 0"
    }), /*#__PURE__*/_jsx("feBlend", {
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_".concat(id)
    }), /*#__PURE__*/_jsx("feBlend", {
      "in": "SourceGraphic",
      in2: "effect1_dropShadow_".concat(id),
      result: "shape"
    })]
  });
}

function useLevelIndicatorIcon(variant) {
  var bgFill;
  var occupiedFill;
  var pointerDirection;
  var occupiedFillDirection;

  switch (variant) {
    case 'success':
      bgFill = '#E6F1EC';
      occupiedFill = '#007740';
      pointerDirection = 'M58.494 73.302a10.39 10.39 0 0 0 9.875.275l44.392-22.424-49.655 2.785a10.39 10.39 0 0 0-8.413 5.177c-2.868 4.967-1.166 11.319 3.8 14.187';
      occupiedFillDirection = 'M21.008 106.992c-1.25 1.25-3.282 1.255-4.468-.056A63.997 63.997 0 0 1 31.404 8.923a64 64 0 0 1 93.072 34.133c.578 1.67-.404 3.45-2.101 3.944s-3.464-.485-4.052-2.152a57.6 57.6 0 0 0-33.145-34.413 57.6 57.6 0 0 0-64.106 91.97c1.178 1.317 1.186 3.337-.064 4.587';
      break;

    case 'warning':
      bgFill = '#FCF1E6';
      occupiedFill = '#DE7700';
      pointerDirection = 'M56.401 71.15a10.39 10.39 0 0 1-2.822-9.467L63.749 13l10.162 48.684a10.39 10.39 0 0 1-2.823 9.466c-4.056 4.055-10.631 4.056-14.687 0';
      occupiedFillDirection = 'M21.0079 106.992C19.7582 108.242 17.7254 108.247 16.5398 106.936C8.68555 98.2548 3.34858 87.5674 1.14055 76.0287C-1.26833 63.4404 0.157849 50.4189 5.23438 38.6504C10.3109 26.882 18.8039 16.9088 29.6135 10.0225C39.5218 3.71043 50.958 0.258473 62.6626 0.013952C64.4296 -0.0229608 65.8208 1.45919 65.7693 3.22575C65.7179 4.99231 64.2433 6.3734 62.4766 6.42013C52.054 6.69578 41.8793 9.79689 33.0521 15.4203C23.3235 21.6179 15.6798 30.5938 11.1109 41.1854C6.54207 51.777 5.25851 63.4964 7.4265 74.8258C9.39361 85.1055 14.1201 94.6345 21.0718 102.405C22.2502 103.722 22.2576 105.742 21.0079 106.992Z';
      break;

    default:
      bgFill = '#FAE6E9';
      occupiedFill = '#C02';
      pointerDirection = 'M68.767 73.302a10.39 10.39 0 0 1-9.875.275L14.5 51.153l49.655 2.785a10.39 10.39 0 0 1 8.413 5.177c2.868 4.967 1.166 11.319-3.801 14.187';
      occupiedFillDirection = 'M21.0079 106.992C19.7582 108.242 17.7255 108.247 16.5399 106.936C9.39004 99.0334 4.315 89.4558 1.7984 79.0652C-0.718202 68.6746 -0.587899 57.8363 2.15348 47.5376C2.60809 45.8298 4.41792 44.9043 6.10091 45.4437C7.7839 45.9831 8.70178 47.783 8.25667 49.4934C5.86858 58.6696 5.77882 68.3112 8.01856 77.5587C10.2583 86.8062 14.7497 95.3382 21.0718 102.405C22.2502 103.722 22.2576 105.742 21.0079 106.992Z';
  }

  return {
    bgFill: bgFill,
    occupiedFill: occupiedFill,
    pointerDirection: pointerDirection,
    occupiedFillDirection: occupiedFillDirection
  };
}

var variantFilterValues = {
  danger: {
    width: '67.4607',
    height: '31.5396',
    x: '10.5002',
    y: '51.1533',
    id: 'filter0_d_4156_17010'
  },
  warning: {
    width: '28.77',
    height: '69.192',
    x: '49.359',
    y: '13',
    id: 'filter0_d_4156_17022'
  },
  success: {
    width: '67.461',
    height: '31.54',
    x: '49.3',
    y: '51.153',
    id: 'filter0_d_4156_17034'
  }
};